export const EVENT_CODES = {
	PROFILE_CREATE: 'PROFILE CREATE',
	PASSWORD_RESET: 'PASSWORD RESET',
};
